import { render } from "./SField.vue?vue&type=template&id=16367fc9&ts=true"
import script from "./SField.ts?vue&type=script&lang=ts"
export * from "./SField.ts?vue&type=script&lang=ts"

import "./SField.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__